module.exports = __webpack_public_path__ + "img/full6-min.ca952054.png";